<template>
    <!-- «Дуель на кубиках»: кожен кидає кубик, найменше — платить; нічия на найменшому — перекидають лише ці гравці -->
    <div class="bp-wp-game">
        <p class="bp-wp-turn" aria-live="polite">
            <template v-if="state == 'done'">Найменше викинуто: <b>{{ players[loser] }}</b>!</template>
            <template v-else-if="rolling">Кидає <b>{{ players[current] }}</b>…</template>
            <template v-else>{{ round > 1 ? 'Нічия — перекидають. ' : '' }}Кидає <b>{{ players[current] }}</b></template>
        </p>
        <div class="bp-wp-dicebox">
            <BpDice v-if="rolls" :value="face" :roll="rolls"/>
            <span v-else class="bp-wp-dicebox__ic" v-html="icons.dice" aria-hidden="true"></span>
        </div>
        <button type="button" class="bp-wp-btn bp-wp-btn--main" :disabled="rolling || state == 'done'" @click="throwDie()">
            {{ rolling ? 'Летить…' : 'Кинути кубик' }}
        </button>
        <ol class="bp-wp-board">
            <li v-for="(name, i) in players" :key="i" :class="{ 'is-now': i == current && state != 'done', 'is-out': !inRound.includes(i) && state != 'done', 'is-lose': state == 'done' && i == loser }">
                <span class="bp-wp-board__name">{{ name }}</span>
                <span class="bp-wp-board__val">{{ scores[i] != null ? scores[i] : '—' }}</span>
            </li>
        </ol>
    </div>
</template>

<script>
import BpDice from '@/components/BpDice.vue'
import { ICONS } from '@/v2icons'

// Кидок 1,4 с (bp-dice-toss у v2.css) — число з'являється після приземлення
const TOSS_MS = 1450;

export default {
    name: 'GameDice',
    components: { BpDice },
    props: {
        players: { type: Array, required: true }
    },
    data() {
        return {
            icons: ICONS,
            inRound: this.players.map((_, i) => i),
            pos: 0,
            round: 1,
            scores: this.players.map(() => null),
            face: 1,
            rolls: 0,
            rolling: false,
            state: 'play',
            loser: null
        }
    },
    computed: {
        current() {
            return this.inRound[this.pos];
        }
    },
    methods: {
        throwDie() {
            if (this.rolling || this.state == 'done') return;
            const who = this.current;
            this.face = 1 + Math.floor(Math.random() * 6);
            this.rolls++;
            this.rolling = true;
            setTimeout(() => {
                this.$set(this.scores, who, this.face);
                this.rolling = false;
                if (this.pos < this.inRound.length - 1) { this.pos++; return; }
                // Усі в раунді кинули: найменше — платить; кілька з найменшим — новий раунд лише для них
                const min = Math.min(...this.inRound.map(i => this.scores[i]));
                const low = this.inRound.filter(i => this.scores[i] === min);
                if (low.length == 1) {
                    this.loser = low[0];
                    this.state = 'done';
                    setTimeout(() => this.$emit('done', { loser: low[0], note: 'Викинуто ' + min + (this.round > 1 ? ' у переграші' : '') }), 1100);
                    return;
                }
                setTimeout(() => {
                    this.inRound = low;
                    this.pos = 0;
                    this.round++;
                }, 900);
            }, TOSS_MS);
        }
    }
}
</script>
